module.exports = __webpack_public_path__ + "media/images/welcome4-56b2b6b2eafac7404ec29133d91bdebf.jpg";